const pdfContext = (require as any).context('../assets', false, /\.pdf$/)
const licenzaKey:
  | string
  | undefined = (pdfContext.keys() as string[]).find((k: string) =>
  k.includes("Condizioni d'uso licenza")
)

const pdfModule = licenzaKey ? pdfContext(licenzaKey) : null

export const licenzaPdfUrl: string =
  (typeof pdfModule === 'string' ? pdfModule : '') ||
  (pdfModule ? pdfModule.default ?? '' : '')

export const licenzaPdfFilename: string = licenzaKey
  ? licenzaKey.replace('./', '')
  : ''
